export default __webpack_public_path__ + "static/media/vision.16ba2443.jpeg";